import { Check } from 'react-feather';
import { useEffect, useState } from 'react';
import { fetchCohortImage } from '../../../services/schools';
import AS from '../../../assets/images/as.png';

interface SignupDisplayProps {
  cohort: string;
  isGroupSignup: boolean;
  isLogin: boolean;
}

interface ConfigObject {
  superhead?: string;
  title: string;
  image?: string;
  benefits: string[];
  curator?: string;
  curatorImage?: string;
}

const DEFAULT_TITLE = 'Med school can be simpler';

// const DEFAULT_BENEFITS = [
//   'Over 12,000 QBank questions',
//   'Over 25,000 flashcards',
//   'Over 1,700 library articles',
// ];

const SIGNUP_DISPLAY_CONFIG: Record<string, ConfigObject> = {
  stanford: {
    superhead: 'Stanford School of Medicine',
    title: 'Science of Medicine 1',
    benefits: [],
  },
  ucsf: {
    superhead: 'UCSF School of Medicine',
    title: 'Pathogens & Host Defenses',
    benefits: [],
  },
  group: {
    title: 'Join an Ora group',
    benefits: [],
  },
  default: {
    title: DEFAULT_TITLE,
    benefits: [],
  },
};

const SignupDisplay = ({
  cohort,
  isGroupSignup,
  isLogin,
}: SignupDisplayProps) => {
  const [cohortImage, setCohortImage] = useState<string | null>(null);

  const dispalyConfig = isGroupSignup
    ? SIGNUP_DISPLAY_CONFIG.group
    : cohort && SIGNUP_DISPLAY_CONFIG[cohort]
      ? SIGNUP_DISPLAY_CONFIG[cohort]
      : SIGNUP_DISPLAY_CONFIG.default;
  const benefits = dispalyConfig.benefits;

  useEffect(() => {
    if (cohort) {
      getCohortImage(cohort);
    }
  }, [cohort]);

  const getCohortImage = async (cohort: string) => {
    const response = await fetchCohortImage(cohort);
    if (response) {
      setCohortImage(response);
    }
  };

  return (
    <>
      <div className="signup-display">
        <div className="signup-display_content">
          <div
            className={`signup-display_content_header ${
              cohort ? 'is-cohort' : ''
            }`}
          >
            <h1>
              {dispalyConfig.superhead && (
                <span className="superhead">{dispalyConfig.superhead}</span>
              )}
              <span className="title">{dispalyConfig.title}</span>
            </h1>
          </div>
          {benefits.length > 0 && (
            <div className="benefits">
              {/* <p>Sign up for free to try out:</p> */}
              <ul>
                {benefits.map((benefit, index) => (
                  <li key={index}>
                    <Check />
                    {benefit}
                  </li>
                ))}
              </ul>
            </div>
          )}
          {!dispalyConfig.curator && !cohort && (
            <div className="testimonial">
              <p>
                <span>"</span>
                This is a smarter UWorld. It has UWorld-equivalent questions,
                and it quickly identifies your weaknesses and builds a
                regimented plan to help you attack them. It's basically a blend
                between UWorld and Anki.
              </p>
              <div className="credit">
                <div className="credit_image">
                  <img src={AS} alt="Aditya Shah" />
                </div>
                <div className="credit_text">
                  <p>Aditya Shah, MS2</p>
                  <p>CMU College of Medicine</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {cohort && cohortImage && !isLogin && (
        <div className="cohort-background-wrapper">
          <div className="cohort-background-wrapper_overlay"></div>
          <img
            className="cohort-background"
            src={cohortImage}
            alt={dispalyConfig.title}
          />
        </div>
      )}
    </>
  );
};

export default SignupDisplay;
